<template>
    <div v-if="shopAnalysisData.length" id="analysis" class="carrier-list-data">
      <div class="block">
        <Title title="商品类目构成" />
        <div class="options">
          <span class="btn" :class="{'btn-active': sort === 'goods'}" @click="changeSort('goods')">商品数</span>
          <span class="btn" :class="{'btn-active': sort === 'soldNum'}" @click="changeSort('soldNum')">销量</span>
          <span class="btn" :class="{'btn-active': sort === 'sales'}" @click="changeSort('sales')">销售额</span>
        </div>
        <Chart :analysisData="categoryData" />
        <Table :analysisData="categoryData" :total="total" :label="label" />
      </div>
      <Divider />
      <div class="block">
        <Title title="商品平台分布" />
        <div class="options">
          <span class="btn" :class="{'btn-active': sort === 'goods'}" @click="changeSort('goods')">商品数</span>
          <span class="btn" :class="{'btn-active': sort === 'soldNum'}" @click="changeSort('soldNum')">销量</span>
          <span class="btn" :class="{'btn-active': sort === 'sales'}" @click="changeSort('sales')">销售额</span>
        </div>
        <Chart :analysisData="platformData" />
        <Table :analysisData="platformData" :total="total" :label="label" />
      </div>
      <Divider />
      <div class="block">
        <Title title="商品价格区间" />
        <div class="options">
          <span class="btn" :class="{'btn-active': sort === 'goods'}" @click="changeSort('goods')">商品数</span>
          <span class="btn" :class="{'btn-active': sort === 'soldNum'}" @click="changeSort('soldNum')">销量</span>
          <span class="btn" :class="{'btn-active': sort === 'sales'}" @click="changeSort('sales')">销售额</span>
        </div>
        <Chart :analysisData="priceData" />
        <Table :analysisData="priceData" :total="total" :label="label" />
      </div>
      <div v-if="$store.state.userLevel <= 94" class="block">
        <Title title="带货品牌分析" :new="true" />
        <div class="options">
          <span class="btn" :class="{'btn-active': sort === 'goods'}" @click="changeSort('goods')">商品数</span>
          <span class="btn" :class="{'btn-active': sort === 'soldNum'}" @click="changeSort('soldNum')">销量</span>
          <span class="btn" :class="{'btn-active': sort === 'sales'}" @click="changeSort('sales')">销售额</span>
        </div>
        <Chart :analysisData="brandData" />
        <Table :analysisData="brandData" :total="total" :label="label" />
      </div>
      <BlurImage src="https://s6.bihukankan.com/img/0108brand-blur.png" v-else class="blurImg"/>
      <div v-if="$store.state.userLevel <= 94" class="block">
        <Title title="合作店铺分析" :new="true" />
        <div class="options">
          <span class="btn" :class="{'btn-active': sort === 'goods'}" @click="changeSort('goods')">商品数</span>
          <span class="btn" :class="{'btn-active': sort === 'soldNum'}" @click="changeSort('soldNum')">销量</span>
          <span class="btn" :class="{'btn-active': sort === 'sales'}" @click="changeSort('sales')">销售额</span>
        </div>
        <Chart :analysisData="shopData" />
        <Table :analysisData="shopData" :total="total" :label="label" />
      </div>
      <BlurImage src="https://s6.bihukankan.com/img/1638322216编组 7.png" v-else class="blurImg"/>
    </div>
    <NoneData v-else propsText="该主播在所选时间范围内没有卖货" :height="5" :imgSize="1.65"/>
</template>

<script>
import Title from './components/Title';
import Divider from './components/Divider';
import Chart from './components/Chart';
import Table from './components/Table';

import calcRate from './calcRate';

export default {
  components: { Title, Divider, Chart, Table },
  props: { time: Array, default: () => ([]) },
  data() {
    return {
      sort: 'sales',
      label: '销售额',
      totalSales:0,
      totalVolume:0,
      shopAnalysisData:[],
      loading: true,
    }
  },
  computed: {
    total() {
      const obj = {
        sales: this.totalSales,
        soldNum: this.totalVolume,
        goods: this.shopAnalysisData.length
      }
      return obj[this.sort]
    },
    categoryData() {
      let data = this.$_.groupBy(this.shopAnalysisData, 'category');
      delete data.undefined;
      let arr = []
      if (this.sort === 'goods') {
        for (const key in data) {
          arr.push({ name: key, value: data[key].length })
        }
      } else {
        arr = this.$_.keys(data).map(ele => {
          return {
            name: ele,
            value: this.$sum(data[ele].map(val => Number(val[this.sort])))
          };
        })
      }
      arr.sort((a, b) => b.value - a.value);
      return this.$sixTable(arr, 'name', 'value');
    },
    brandData() {
      let data = this.$_.groupBy(this.shopAnalysisData, ele => ele?.brand?.name || '其他');
      let arr = []
      if (this.sort === 'goods') {
        for (const key in data) {
          arr.push({ name: key, value: data[key].length })
        }
      } else {
        arr = this.$_.keys(data).map(ele => {
          return {
            name: ele,
            value: this.$sum(data[ele].map(val => Number(val[this.sort])))
          };
        })
      }
      arr.sort((a, b) => b.value - a.value);
      return this.$sixTable(arr, 'name', 'value');
    },
    shopData(){
      let data = this.$_.groupBy(this.shopAnalysisData, ele => ele?.shop?.name || '其他');
      let arr = []
      if (this.sort === 'goods') {
        for (const key in data) {
          arr.push({ name: key, value: data[key].length })
        }
      } else {
        arr = this.$_.keys(data).map(ele => {
          return {
            name: ele,
            value: this.$sum(data[ele].map(val => Number(val[this.sort])))
          };
        })
      }
      arr.sort((a, b) => b.value - a.value);
      return this.$sixTable(arr, 'name', 'value');
    },
    platformData() {
      const fn = val => {
        const platform = this.$_.get(val, 'source[0].source');
        return this.$store.state.sourceIconPosition[platform].name;
      };
      const data = this.$_.groupBy(this.shopAnalysisData, fn);
      return calcRate(data, this.sort);
    },
    priceData() {
      const fn = val => {
        if (val.price < 20) {
          return '20元以下';
        }
        if (20 < val.price && val.price < 50) {
          return '20元-50元';
        }
        if (50 < val.price && val.price < 100) {
          return '50元-100元';
        }
        if (100 < val.price && val.price < 500) {
          return '100元-500元';
        }
        return '500元以上';
      };
      const data = this.$_.groupBy(this.shopAnalysisData, fn);
      return calcRate(data, this.sort);
    }
  },
  watch:{
    '$props.time' :{
      immediate:true,
      handler(){ this.getData() }
    }
  },
  methods: {
    /** 获取数据 */
    getData() {
      this.$get({
        road: 'ecommerce',
        data: { road: 'gifshow', anchorId: this.$route.params.id },
        params: {
          time: `{"$between": [${this.$props.time}]}`,
          source: 'yellowShoppingCart'
        },
        version: 'v2'
      }).then(res => {
            this.shopAnalysisData = res;
            this.calcSummary();
          })
          .catch(err => { this.isVip = false })
    },
    calcSummary() {
      let sales = 0;
      let volume = 0;
      for (const goods of this.shopAnalysisData) {
        sales += Number(goods.sales);
        volume += Number(goods.soldNum);
      }
      this.totalSales = sales;
      this.totalVolume = volume;
    },
    changeSort(text) {
      this.sort = text
      const obj = {
        sales: '销售额',
        soldNum: '销量',
        goods: '商品数'
      }
      this.label = obj[text]
    }
  }
};
</script>

<style lang="less" scoped>
#analysis {
  .chart {
    width: 100vw;
    height: 5rem;
  }

  .block {
    padding-bottom: 0.6rem;

    .options {
      display: flex;
      justify-content: flex-end;
      margin-right: 0.3rem;

      .btn + .btn {
        margin-left: 0.2rem;
      }

      .btn-active {
        color: #2a89f4;
      }
    }
  }
  .blurImg{
    width: 100%;
    height:9.2rem;
  }
}
</style>
